// common/services/player/inviteFamilyContact.ts
import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'

export type InviteFamilyContactInput = {
  /** Player whose family the contact is being invited to. */
  playerId: string
  /** Given name for the new contact. */
  name_first: string
  /** Family name for the new contact. */
  name_last: string
  email: string
  /** E.164 phone number (e.g. '+14165550123'). Optional per the design. */
  phone_number?: string | null
  /**
   * BE relationship type id (RelationshipType). Omitted/null when the user
   * leaves the dropdown blank so the backend can apply its default.
   */
  relationship_type_id?: number | null
  /** Whether the contact gets administrative access to the player. */
  is_primary?: boolean
}

export type InviteFamilyContactResponse = {
  id?: string
  status?: 'sent' | 'pending'
} & Record<string, unknown>

/**
 * POST /players/:playerId/family/invite — sends a family-contact invitation.
 * Body: { name_first, name_last, email, phone_number?, relationship_type_id? }.
 */
export const inviteFamilyContact = async (
  input: InviteFamilyContactInput
): Promise<InviteFamilyContactResponse> => {
  const { playerId, ...body } = input
  const { data } = await req(ENDPOINTS.PLAYERS.INVITE_PLAYER_FAMILY(playerId), {
    method: 'POST',
    body: JSON.stringify(body),
  })
  return data as InviteFamilyContactResponse
}
